import React, { useContext } from "react"
import { NewOrderFormPage as SharedNewOrderFormPage } from "@stjeans/shared-frontend/order-form"
import AppContext from "../../AppContext.jsx"
import api from "../../api.js"

export default function OrderFormPage() {
    const { app } = useContext(AppContext)
    return (
        <SharedNewOrderFormPage
            app={app}
            api={api}
            enableDropOffLocationSelect={false}
            enableMagicWandTool={false}
            enablePrepaidAmount={false}
            getOrderFromTemplateFunc={api.getOrderFromTemplate}
        />
    )
}

